module.exports = __webpack_public_path__ + "img/smartwatch.cf50bef9.svg";